export const MILES = 1;
export const KM = 2;
export const HOURS = 3;
export const NOT_AVAILABLE = 5;
export const SEE_REPORT = 6;
export const NOT_APPLICABLE = 9;
